var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.12,
    height: 32.12,
    viewBox: "0 0 32.12 32.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Diamond",
    d: "M27.2,7.186a.881.881,0,0,1,.783.443l4.459,7.581.007.012a.877.877,0,0,1,.044.089l-.051-.1a.878.878,0,0,1,.121.446v.023q0,.022,0,.043l0-.066a.886.886,0,0,1-.011.142c0,.013,0,.025-.007.037a.83.83,0,0,1-.023.087l-.009.025a.818.818,0,0,1-.032.079l-.017.034a.878.878,0,0,1-.137.194l-.006.006L17.174,32.248a.884.884,0,0,1-1.348,0L.681,16.262a.88.88,0,0,1-.12-1.051L5.024,7.625a.874.874,0,0,1,.7-.437l.037,0H27.2ZM16.5,29.55l-.8,1.766h1.6Zm5.9-13.014H10.594L16.5,29.55Zm-13.744,0h-5.3l10.166,10.73Zm20.973,0h-5.3l-4.869,10.73ZM5.684,9.974l-2.825,4.8h5Zm21.632,0-2.179,4.8h5ZM16.583,9.34l-5.175,5.436h10.4Zm-2.056-.394H7.15l2.382,5.248Zm11.323,0h-7.2l4.893,5.089ZM24.283,2.4a.88.88,0,0,1-.036,1.244L22.462,5.333a.88.88,0,0,1-1.208-1.28l1.786-1.687A.88.88,0,0,1,24.283,2.4ZM9.961,2.367l1.786,1.687a.88.88,0,0,1-1.208,1.28L8.752,3.646a.88.88,0,1,1,1.208-1.28ZM16.5.44a.88.88,0,0,1,.88.88V3.85a.88.88,0,1,1-1.76,0V1.32A.88.88,0,0,1,16.5.44Z",
    transform: "translate(-0.44 -0.44)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.78e75afe8e511690e630ee9f0bda1ccb.svg";
export { ForwardRef as ReactComponent };